import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, Input, App, Upload, Modal } from 'antd';
import type { UploadProps } from 'antd';
import { saveMessageInfo, getChatRoomList, getChatDetailList } from '@/api/message';
import styles from './index.module.scss';
import { useAppSelector } from '@/store/hooks';
import { LeftOutlined } from '@ant-design/icons';
import iocn1 from '@/assets/images/组 2262@2x.png';
import iocn2 from '@/assets/images/组件 2 – 2@2x.png';
import iocn3 from '@/assets/images/路径 1616@2x.png';
import iocn4 from '@/assets/images/路径 1617@2x.png';
import iocn5 from '@/assets/images/组 2264@2x.png';
import iocn6 from '@/assets/images/组 2265@2x.png';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const { TextArea } = Input;

interface ChatListProps {
  // children: React.ReactNode;
  // getMessage?: (str: string) => void; // 可选的回调函数
}

interface Iuser {
  phone: string;
  photo: string;
  merchant_id: string;
  first_name?: string;
  last_name?: string;
  user_id: string;
}


interface Imerchant {
  merchant_id: string | null;
  merchant_name: string;
}

interface IChatMessage {
  name: string;
  room_id: string;
  create_time: string;
  avatar: string;
  admin: Iuser;
  member: Iuser;
  is_read: boolean;
}


interface IChatDetailMessage {
  message_id?: string;
  message_type: number; //1text 2image file3
  user_sender?: any;
  user_sender_avatar?: string;
  user_receiver?: any;
  user_receiver_avatar?: string;
  content: string;
  create_time?: string;
  filename?: string;
  room_id?: string;

  // userName: string;
  // itMe: boolean;
  // avatar: string;
  // fileSize?: string;
}

//表情包集合
const emojiList = [
  "😀",
  "😁",
  "😅",
  "😂",
  "😎",
  "😍",
  "😘",
  "🥺",
];


const ChatList: React.FC<ChatListProps> = () => {
  const { t, i18n } = useTranslation();
  //获取token
  const token = useAppSelector((state) => state.user.token);

  //获取路由
  const navigate = useNavigate();

  //聊天内容列表长度
  const prevLengthRef = useRef(0);

  // 获取查询参数
  const [searchParams] = useSearchParams();

  //是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);

  //是否显示聊天列表（区分手机端的时候使用）
  const [isShowChatSide, setIsShowChatSide] = useState<Boolean>(true);

  //是否显示聊天窗口（区分手机端的时候使用）
  const [isShowChatMain, setIsShowChatMain] = useState<Boolean>(true);

  //message弹窗对象
  const { message } = App.useApp();

  //聊天内容dom对象
  const maincontentRef = useRef<HTMLDivElement>(null);

  //获取用户信息
  const userInfo = useAppSelector((state) => state.user.userInfo);

  //聊天联系人列表定时器
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  //聊天内容定时器
  const timerChatDetailListRef = useRef<NodeJS.Timeout | null>(null);

  //聊天的时候把内容列表拉到最底部
  const handleScroll = () => {
    if (maincontentRef.current) {

      setTimeout(() => {

        maincontentRef?.current?.scrollTo({
          top: maincontentRef?.current?.scrollHeight,
          behavior: 'smooth'
        });

      }, 800);

    }
  };

  //消息列表关键字搜索
  const [searchValue, setSearchValue] = useState<string>('');

  // 搜索消息列表处理键盘回车事件
  const searchHandleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      setChatMessageList(chatMessageListCopy.filter((item) => item?.name.includes(searchValue)));
    }
  }

  // 接口拿过来的聊天联系人列表
  const [chatMessageListCopy, setChatMessageListCopy] = useState<IChatMessage[]>([
    // {
    //   avatar: '//img.alicdn.com/imgextra/i3/2789488531/O1CN01HE3Jz62CtFtBL7tvP_!!2789488531.jpg',
    //   shopName: '鼎扬科工',
    //   create_time: '2023/8/29',
    //   room_id:'1'
    // },

  ]);


  // 可以过滤的聊天消息列表
  const [chatMessageList, setChatMessageList] = useState<IChatMessage[]>([]);

  // 聊天消息索引
  const [chatMessageIndex, setChatMessageIndex] = useState<number>(-1);

  //选中聊天者信息
  const [chatMessageInfo, setChatMessageInfo] = useState<IChatMessage>({
    is_read:true,
    admin: {
      phone: '',
      photo: '',
      merchant_id: '',
      first_name: '',
      last_name: '',
      user_id: ''
    },
    //聊天对象信息
    member: {
      phone: '',
      photo: '',
      merchant_id: '',
      first_name: '',
      last_name: '',
      user_id: ''
    },
    create_time: '',
    room_id: '',
    name: '',
    avatar: ''
  });

  //聊天消息选择事件
  const chatMessageSelect = (index: number) => {
    //PC端点击聊天列表不能重复点击，因为展示在一起
    if (!isMobile && index == chatMessageIndex) {
      return;
    }

    const selectItem = chatMessageList[index];
    setChatMessageInfo(selectItem);

    //获取聊天详情
    getChatDetailListAction(selectItem.room_id);

    setChatMessageIndex(index);



    //关闭聊天列表打开聊天窗口
    if (!!isMobile) {
      setIsShowChatSide(false);
      setIsShowChatMain(true);
    }

    //轮询查询最新聊天记录
    if (timerChatDetailListRef.current) clearInterval(timerChatDetailListRef.current);
    timerChatDetailListRef.current = setInterval(() => {
      getChatDetailListAction(selectItem.room_id);
    }, 1500);
  }

  //返回聊天列表
  const backChatList = () => {
    setIsShowChatSide(true);
    setIsShowChatMain(false);
    if (timerChatDetailListRef.current) clearInterval(timerChatDetailListRef.current);
  }

  //发送文本消息内容
  const [messageValue, setMessageValue] = useState<string>('');

  //调用发送消息接口
  const sendMessageAction = (params: IChatDetailMessage) => {

    saveMessageInfo(params).then((res) => {
      if (res.code == 200) {
        getChatDetailListAction(chatMessageInfo.room_id);
      }
    });

  }

  //获取聊天联系人列表
  const getChatRoomListAction = (flag: boolean = false) => {
    getChatRoomList().then((res) => {
      if (res.code == 200) {
        setChatMessageListCopy(res.data);
        setChatMessageList(res.data);

        if (!flag) {
          return;

        }

        // 获取查询参数
        const chatRoomId = searchParams.get('chatRoomId');
        if (chatRoomId) {
          const findIndex = res.data.findIndex((item: any) => item.room_id == chatRoomId);
          if (findIndex > -1) {
            const selectItem = res.data[findIndex];
            setChatMessageInfo(selectItem);
            setChatMessageIndex(findIndex);

            getChatDetailListAction(selectItem.room_id);

            //关闭聊天列表打开聊天窗口
            if (!!isMobile) {
              setIsShowChatSide(false);
              setIsShowChatMain(true);
            }
          }
        }

      }
    });
  }


  //获取聊天内容列表详情
  const getChatDetailListAction = (room_id: string) => {
    getChatDetailList({ room_id: room_id }).then((res) => {
      if (res.code == 200) {

        setChatDetailList(prev => {
          
          prevLengthRef.current = prev.length;
          return res.data;
        });
      }
    });
  }



  //发送消息
  const sendAction = () => {
    if (messageValue.trim()) {
      console.log('messageValue', messageValue);

      //此处用接口发送消息
      const params = {
        room_id: chatMessageInfo.room_id,
        //发起人
        user_sender_id: userInfo?.user_id || '',
        //接收人
        user_receiver_id: chatMessageInfo?.member?.user_id || '',
        //消息类型
        message_type: 1,
        content: messageValue,
      };



      sendMessageAction(params);

      setMessageValue('');

    }
  }

  // 处理移动端发送事件
  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    sendAction();
  }

  // 处理键盘回车事件
  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && e.ctrlKey) {
      sendAction();
    }
  }


  //表情包显示隐藏
  const [showEmoji, setShowEmoji] = useState<boolean>(false);



  //图片上传配置
  const ImageProps: UploadProps = {
    name: 'file',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    accept: ".png,.jpeg,.jpg,.gif",
    headers: {
      //记得修改
      token: `${token}`,
    },
    maxCount: 1, // 只允许上传一个
    showUploadList: false, // 不显示fileList
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error(t("ChatList.Imagemustsmaller"));
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {
      //debugger
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {




        //此处用接口发送消息
        const params = {
          room_id: chatMessageInfo.room_id,
          //发起人
          user_sender_id: userInfo?.user_id || '',
          //接收人
          user_receiver_id: chatMessageInfo?.member?.user_id || '',
          //消息类型
          message_type: 2,
          content: info?.file?.response?.data?.url,
        };

        sendMessageAction(params);


      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} t("ChatList.fileuploadfailed")`);
      }
    },
  };




  //附件上传配置
  const FileProps: UploadProps = {
    name: 'file',
    action: `${process.env.REACT_APP_API_URL}/api/product/save_upload_file`,
    headers: {
      //记得修改
      token: `${token}`,
    },
    maxCount: 1, // 只允许上传一个
    showUploadList: false, // 不显示fileList
    beforeUpload: (file) => {
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
        message.error(t("ChatList.Imagemustsmaller"));
      }
      return isLt10M; // 返回 false 阻止上传
    },
    onChange(info) {
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {


        //此处用接口发送消息
        const params = {
          room_id: chatMessageInfo.room_id,
          //发起人
          user_sender_id: userInfo?.user_id || '',
          //接收人
          user_receiver_id: chatMessageInfo?.member?.user_id || '',
          //消息类型
          message_type: 3,
          content: info?.file?.response?.data?.url,
          filename: info?.file?.name,
        };

        sendMessageAction(params);

      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} t("ChatList.fileuploadfailed")`);
      }
    },
  };


  //聊天详情列表（跟客服的聊天内容）
  const [chatDetailList, setChatDetailList] = useState<IChatDetailMessage[]>([
    // {
    //   message_type: 1,

    //   user_sender: {
    //     user_id: "cdadex1753145453245",
    //     first_name: "client",
    //     last_name:'53245',
    //   },
    //   user_sender_avatar:'//img.alicdn.com/imgextra/i3/2789488531/O1CN01HE3Jz62CtFtBL7tvP_!!2789488531.jpg',
    //   user_receiver: {
    //     user_id: "cdadex1753145453245",
    //     first_name: "client",
    //     last_name:'53245',
    //   },
    //   user_receiver_avatar:'//img.alicdn.com/imgextra/i3/2789488531/O1CN01HE3Jz62CtFtBL7tvP_!!2789488531.jpg',
    //   content: '我是买家我在右边',
    //   create_time: '2025-06-18 16:44:51',
    // },



  ]);

  //查看大图显示隐藏
  const [previewVisible, setPreviewVisible] = useState(false);
  //大图的url
  const [previewImage, setPreviewImage] = useState('');


  //mounted
  useEffect(() => {

    getChatRoomListAction(true);

    // 开启定时器
    timerRef.current = setInterval(() => {
      getChatRoomListAction();
    }, 10000); // 每 10 秒一次


    // 获取查询参数
    const chatRoomId = searchParams.get('chatRoomId');

    if (chatRoomId) {

      //轮询查询最新聊天记录
      timerChatDetailListRef.current = setInterval(() => {
        getChatDetailListAction(chatRoomId);
      }, 1500);
    }



    return () => {

      // 离开页面时清除定时器
      if (timerRef.current) clearInterval(timerRef.current);
      if (timerChatDetailListRef.current) clearInterval(timerChatDetailListRef.current);
    };
  }, []);

  //监听isMobile的变化
  useEffect(() => {
    //手机端默认展示聊天列表，隐藏聊天窗口
    if (!!isMobile) {
      setIsShowChatSide(true);
      setIsShowChatMain(false);
    }

  }, [isMobile]);
  

  // 监听聊天记录数组变化，把聊天窗口滚动条拉到最底部
  useEffect(() => {
    
    if (prevLengthRef.current < chatDetailList.length) {
      handleScroll();
    }
    
  }, [chatDetailList]);



  return (
    <div className={styles['chat-container']}>

      {/* 左侧联系人列表 */}
      <div
        className={styles['chat-sidebar']}
        style={{ display: isShowChatSide ? 'flex' : 'none' }}
      >
        <div className={styles['sidebar-header']}>
          <img src={iocn1} alt="" />
          <span>{t('chatList.Chatlist')}</span>
        </div>
        <div className={styles['sidebar-search']}>
          <img src={iocn2} alt="" />
          <input
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onKeyDown={searchHandleKeyDown}
            type="text"
            placeholder={t("ChatList.Pleasesearchcontacts")}
          />
        </div>
        <div className={styles['sidebar-list']}>
          {
            chatMessageList.map((item, index) => (
              <div
                key={index}
                onClick={() => chatMessageSelect(index)}
                className={`${styles['sidebar-item']} ${chatMessageIndex == index ? styles['sidebar-item-active'] : ''}`}>
                {!item.is_read&&<div className={styles['is-unread']}></div>}
                <img className={styles['avatar']} src={item?.avatar || ''} alt="avatar" />
                <div className={styles['item-info']}>
                  <div className={styles['item-info-top']}>
                    <div
                      className={`${styles['item-title']} overflowText`}
                      title={item?.name}
                    >{item?.name}</div>
                    <div className={styles['item-date']}>{item.create_time && item.create_time.slice(0, 10)}</div>
                  </div>

                  <div className={`${styles['item-info-bottom']} overflowText`}>
                    {/* {item.newMessage}
                    121212 */}
                  </div>

                </div>
              </div>
            ))
          }
        </div>
      </div>
      {/* 左侧联系人列表 */}


      {/* 中间聊天窗口 */}
      <div
        className={styles['chat-main']}
        style={{ display: isShowChatMain ? 'flex' : 'none' }}
      >
        <div className={styles['main-header']}>
          {
            isMobile &&
            <LeftOutlined
              className={styles['main-header-icon']}
              onClick={backChatList}
            />
          }

          {chatMessageIndex > -1 && chatMessageInfo.name}
        </div>

        {/* 聊天内容区 */}
        <div className={styles['main-content']} ref={maincontentRef}>
          {
            chatMessageIndex == -1 &&
            <div className={styles['main-content-empty']}>{t('chatList.Pleaseselectachatpartner')}</div>
          }
          {chatMessageIndex > -1 && chatDetailList.map((item, idx) => (
            <div
              key={idx}
              className={
                item?.user_sender?.user_id == userInfo?.user_id
                  ? styles['chat-row-right']
                  : styles['chat-row-left']
              }
            >
              <div className={styles['chat-meta']}>
                {/* 接收人 */}
                {
                  !(item?.user_sender?.user_id == userInfo?.user_id) &&
                  <>
                    <img
                      className={styles['chat-avatar']}
                      style={{ marginRight: '8px' }}
                      src={item.user_sender_avatar}
                      alt="avatar"
                    />
                    <span className={`${styles['chat-username']} overflowText`}>{item?.user_sender?.nick_name}</span>
                    <span className={styles['chat-date']}>{item.create_time}</span>
                  </>

                }


                {/* 发送人 */}
                {
                  item?.user_sender?.user_id == userInfo?.user_id &&
                  <>
                    <span className={styles['chat-date']}>{item.create_time}</span>
                    <span className={`${styles['chat-username']} overflowText`}>{item?.user_sender?.nick_name}</span>
                    <img
                      className={styles['chat-avatar']}
                      src={item.user_sender_avatar}
                      alt="avatar"
                    />
                  </>

                }

              </div>
              {/* 文本消息 */}
              {item.message_type === 1 && (
                <div className={styles['chat-bubble']}>{item.content}</div>
              )}
              {/* 图片消息 */}
              {item.message_type === 2 && (
                <div
                  className={styles['chat-img-box']}
                  onClick={() => {
                    setPreviewImage(item.content);
                    setTimeout(() => setPreviewVisible(true), 500);
                  }}
                  style={{ cursor: 'pointer' }}
                >
                  <img src={item.content} alt="图片" className={styles['chat-img']} />
                </div>
              )}
              {/* 文件消息 */}
              {item.message_type === 3 && (
                <div className={styles['chat-bubble-file']}>
                  <div className={`${styles['file-icon']}`}>
                    {item.filename?.slice(item.filename.indexOf('.') + 1).toLocaleUpperCase()}
                  </div>
                  <div className={styles['file-info']}>
                    <div className={styles['file-name']}>{t("ChatList.File")}</div>
                    {/* <div className={styles['file-size']}>{'0.0B'}</div> */}
                  </div>
                  <span
                    className={styles['file-download']}

                    onClick={() => {
                      const link = document.createElement('a');
                      link.href = item.content;
                      link.target = '_blank';
                      link.download = item.filename || 'download';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >{t("ChatList.Download")}</span>


                </div>
              )}
              {/* <div className={styles['chat-status']}>已读</div> */}
            </div>
          ))}
        </div>
        {/* 聊天内容区 */}


        {/* 聊天输入框 */}
        {
          chatMessageIndex > -1 &&
          <div className={styles['main-footer']}>
            <div className={styles['main-footer-top']}>
              <div className={styles['footer-top-img-box']}>
                <div className={styles['footer-top-img1-box']}>
                  <img src={iocn3} alt="" className={styles['footer-top-img1']} onClick={() => setShowEmoji(!showEmoji)} />
                  {
                    showEmoji &&
                    <div className={styles['footer-expression']}>
                      {
                        emojiList.map((item, index) => (
                          <span key={index}
                            onClick={() => { setShowEmoji(!showEmoji); setMessageValue(messageValue + item) }}
                          >{item}</span>
                        ))
                      }
                    </div>
                  }

                </div>
                <Upload {...ImageProps}>
                  <img src={iocn4} alt="" className={styles['footer-top-img2']} />
                </Upload>
                <Upload {...FileProps}>
                  <img src={iocn5} alt="" className={styles['footer-top-img3']} />
                </Upload>
                {/* <img src={iocn6} alt="" className={styles['footer-top-img4']} /> */}
              </div>
              <div className={styles['footer-top-num-box']}>
                {messageValue.length}/500
              </div>
            </div>
            <form onSubmit={handleSearch}>
              <TextArea
                className={styles['chat-input']}
                value={messageValue}
                onChange={(e) => setMessageValue(e.target.value)}
                placeholder="Please enter a message"
                autoSize={{ minRows: 3, maxRows: isMobile ? 3 : 5 }}
                onKeyDown={handleKeyDown}
                maxLength={500}
              />

            </form>
            <div className={styles['send-box']}>
              <button
                className={styles['send-btn']}
                style={isMobile ? { width: '100%', height: 48, fontSize: 18 } : {}}
                onClick={sendAction}>send</button>
            </div>


          </div>
        }

        {/* 聊天输入框 */}
      </div>
      {/* 中间聊天窗口 */}

      {/* 右侧联系人详情 */}
      {
        chatMessageIndex > -1 &&
        <div className={styles['chat-detail']} 
        onClick={() => !!chatMessageInfo?.admin?.merchant_id && navigate(`/storeDetail/${chatMessageInfo?.admin?.merchant_id}`)}>
          <img className={styles['detail-avatar']} src={chatMessageInfo.avatar} alt="avatar" />
          <div className={styles['detail-title']}>{chatMessageInfo.name}</div>
          {/* <button className={styles['detail-btn']}>Enter Shop {chatMessageInfo.member.merchant_id}</button> */}
        </div>
      }

      {/* 右侧联系人详情 */}

      {/* 查看大图 */}
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        width="auto"
        centered
      >
        <img src={previewImage} alt="大图" style={{ maxWidth: '90vw', maxHeight: '80vh', marginTop: '40px' }} />
      </Modal>
      {/* 查看大图 */}

    </div>
  );
};

export default ChatList; 